import {useCallback, useEffect, useMemo, useState} from "react";
import axios from "axios";

export default function InstallPage() {
    const BX24 = useMemo(() => window.BX24, [])

    const [appInitialized, setAppInitialized] = useState(false)
    BX24.init(() => setAppInitialized(true));

    const makeRandomString = useCallback((length) => {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }, [])

    const installApplication = useCallback(async() => {
        const bx24Params = BX24.getAllParams()
        const headers = {
            "X-ACCESS-TOKEN": bx24Params.AUTH_ID,
            "X-ACCESS-TOKEN-EXPIRES": bx24Params.AUTH_EXPIRES,
            "X-REFRESH-TOKEN": bx24Params.REFRESH_ID,
            "X-PORTAL-MEMBER-ID": bx24Params.MEMBER_ID,
            "X-PORTAL-DOMAIN": bx24Params.DOMAIN
        }
        const data = {
            fingerprint: makeRandomString(30)
        }
        const response = await axios.post(
            'https://hr.wfbot.ru/api/base/install', data, {
                headers: headers
            }
        )
        console.log(response)
    }, [BX24])

    if (appInitialized) {
        return <>
            <button onClick={installApplication}>
                Установить приложение
            </button>
        </>
    }
}
